import { useCurrentCampagne } from '@common/hooks/campagne';
import { useGetCampagneRncpsDistinctFieldQuery } from '@common/services';
import { RncpFilterField } from '@common/services/rncp';
import { SelectOption } from '@common/ui';
import { SetUtils } from '@common/utils';
import React from 'react';
import { DropdownSelectionFilter } from '../DropdownSelectionFilter';

export const NiveauCertificationFilter = ({ niveau, onNiveauChange }: NiveauCertificationFilterProps) => {
  const { campagne } = useCurrentCampagne();

  const { data: filters = [] } = useGetCampagneRncpsDistinctFieldQuery({
    id: campagne?.id,
    field: RncpFilterField.NIVEAU_CERTIFICATION,
  }, {
    skip: !campagne,
    refetchOnMountOrArgChange: true,
  });

  const options: SelectOption[] = filters.map(type => ({ label: type, value: type }));

  return (
    <DropdownSelectionFilter selection={new Set((niveau) ? [niveau] : [])}
                             onSelectionChange={(selection) => onNiveauChange(SetUtils.takeFirst(selection))}
                             buttonLabel="niveau de certification"
                             options={options}
                             tooltip="Filtrer par niveau de certification" />
  );
};

interface NiveauCertificationFilterProps {
  niveau: string | null;
  onNiveauChange: (type: string) => void;
}